import _ from 'underscore';
import { BaseImportStep } from '../base-import-step';
import { ImportOptionsForm } from './form/index';
import { ImportOptionsSummaryBuilder } from './import-options-summary-builder';
import importOptionsTemplate from './import-options-template.pug';

export class ImportOptionsStep extends BaseImportStep {
  initialize({
    deps,
  }) {
    super.initialize({
      deps,
    });

    this.deps = deps;
    this.isContinueButtonEnabled = true;
    this.summaryBuilder = new ImportOptionsSummaryBuilder({
      i18n: this.i18n,
    });
    this.getImportOptionFields = deps.getImportOptionFields;
  }

  get title() {
    return this.buildTitle({
      activeTitle: this.i18n.get('Import_ImportOptions_WithoutAccount_Title'),
      summaryTitle: this.i18n.get('Import_ImportOptions_WithoutAccount_Summary'),
    });
  }

  get actions() {
    const original = super.actions;

    original[0].enabled = this.isContinueButtonEnabled;
    return original;
  }


  getSummaryInfo() {
    if (!this.importOptionsForm) {
      return '';
    }
    return this.summaryBuilder.generateFormattedOptionsSummary(this.getImportOptions());
  }

  render() {
    this.$el.html(importOptionsTemplate());

    return this;
  }

  renderForm() {
    this.deps.logActivities.renderImportOptions.start();
    const state = this.getState();

    // eslint-disable-next-line max-len
    const jsonFormatEditTaskItemOptions = state.initialSettings && state.initialSettings.ImportUserPreference;

    this.importOptionsForm = new ImportOptionsForm({
      deps: this.deps,
      logTrace: this.logTrace.bind(this),
      previousImportOptions: state.previousImportOptions,
      editTaskItemOptions: state.initialSettings && state.initialSettings.ImportUserPreferences,
      jsonFormatEditTaskItemOptions,
      includePausedCampaigns: state.includePausedCampaigns,
      toggleContinueButton: this.toggleContinueButton,
      getImportOptionFields: this.getImportOptionFields,
      isPauseAdGroupIfNoLocationSupportedEnabled:
        this.deps.isPauseAdGroupIfNoLocationSupportedEnabled,
      isGoogleImport: !_.isUndefined(state.selectedGoogleAccounts) ?
        state.selectedGoogleAccounts.length >= 1 : false,
    });

    this.$('.import-options-container').html(this.importOptionsForm.render().$el);
    this.$('.import-options-container').on('keypress', this.handleFormInputEvent.bind(this));
    this.$('.import-options-container').on('click', this.handleFormInputEvent.bind(this));
    // initial state for user preferences
    this.lastOptions = this.importOptionsForm.getImportUserPreferences();

    this.$('input, textarea').change(() => {
      this.isEdited = true;
    });
    this.logTrace('render import options step');
    this.deps.logActivities.renderImportOptions.stop();
  }

  willShow() {
    if (this.checkIfShouldUpdateAndResetFlagIfTrue()) {
      this.renderForm();
      this.deps.logActivities.configureOptions.startSignal();
    }
  }

  handleFormInputEvent() {
    if (!this.deps.logScenario || !this.deps.logScenario.optionChanged) {
      return;
    }

    if (!this.optionChangedLogger) {
      // reuse the same activity instance so all logs have same activity id (ActID)
      this.optionChangedLogger = this.deps.logScenario.optionChanged.create();
    }

    const currentOptions = this.importOptionsForm.getImportUserPreferences();
    // both last and current are generated from getImportUserPreferences
    // the order of keys are guaranteed to be the same, so we just walk through props
    // and compare each prop, print props different, no need to do deep comparison
    // for performance sake
    _.each(Object.keys(this.lastOptions), (key) => {
      if (!_.isEqual(this.lastOptions[key], currentOptions[key])) {
        const newValue = currentOptions[key];
        const oldValue = this.lastOptions[key];
        this.optionChangedLogger.signal({ key, old: oldValue, new: newValue });
      }
    });
    this.lastOptions = currentOptions;
  }

  updateStateWithFormInfo() {
    let importUserPreferences = this.getImportOptions();
    const state = this.getState();
    const { autoCurrencyConversionEnabled } = state;
    if (!_.isUndefined(autoCurrencyConversionEnabled)) {
      importUserPreferences = _.defaults(
        importUserPreferences,
        { EnableAutoCurrencyConversion: autoCurrencyConversionEnabled }
      );
    }

    this.patchState({
      importOptionsSummary: this.getSummaryInfo(),
      importUserPreferences,
    });
  }

  getUETErrorMessage(errorCode) {
    const defaultMessage = this.i18n.get('UnifiedEventTracking_Tag_Creation_FailedToSaveTag');
    const messageMap = {
      TagWithSameNameAlreadyExistsUnderCustomer: this.i18n.get('UnifiedEventTracking_Tags_DuplicateTagNameError'),
      InvalidTagName: this.i18n.get('UnifiedEventTracking_Tags_PleaseEnterValidTagName'),
      TagNameNullOrEmpty: this.i18n.get('UnifiedEventTracking_Tags_PleaseEnterValidTagName'),
      InvalidTagDescription: this.i18n.get('UnifiedEventTracking_Tags_PleaseEnterValidTagDescription'),
      CustomerUnderMigration: this.i18n.get('UnifiedEventTracking_CustomerMigration'),
      SharedLibraryUserPermissionDenied: this.i18n.get('SharedLibrary_UserPermissionDenied'),
    };

    return messageMap[errorCode] || defaultMessage;
  }

  wizardShouldGoNext() {
    if (this.importOptionsForm && this.importOptionsForm.validate()) {
      return this.importOptionsForm.createUETTag()
        .then((result) => {
          this.updateStateWithFormInfo();
          this.patchState({
            newUETCreated: result.newUETCreated,
          });
          this.deps.logActivities.configureOptions
            .stopSignal(this.getState().importUserPreferences);
          return true;
        }, (response) => {
          this.toggleContinueButton(false);
          this.showErrorMessage(this.getUETErrorMessage(response && response.errorResponseBody &&
            response.errorResponseBody.value && response.errorResponseBody.value[0] &&
            response.errorResponseBody.value[0].Code));
          return false;
        });
    }
    this.toggleContinueButton(false);
    return false;
  }

  toggleContinueButton = (state) => {
    if (state) {
      this.isContinueButtonEnabled = true;
      super.updateAction();
    } else {
      this.isContinueButtonEnabled = false;
      super.updateAction();
    }
  };

  getImportOptions() {
    return this.importOptionsForm.getImportUserPreferences();
  }

  static generateImportUserPreferencesFromPreviousOptions(deps, previousOptions) {
    return ImportOptionsForm
      .generateImportUserPreferencesFromPreviousOptions(deps, previousOptions);
  }
}
